import React from "react";
import Container from "@material-ui/core/Container";
import {
    Card,
    Grid,
    Box,
    Typography,
    Button,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import Navigation from "../../Components/Navigation";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {makeStyles} from "@material-ui/core/styles";
import {colorSecondary} from "../../Constants/theme";
import {Link} from "react-router-dom";
import moment from "moment/moment";

const useStyle = makeStyles(() => ({
    wrapper: {
        padding: "1.5em"
    },
    creditsCount: {
        color: colorSecondary,
        fontWeight: "bold",
        fontSize: "45px"
    },
    textAccent: {
        color: colorSecondary,
        fontWeight: "bold"
    },
    textPlain: {
        letterSpacing: "-0.078px",
        fontSize: "19px"
    },
    listItem: {
        paddingLeft: 0
    },
    link: {
        textDecoration: "none"
    }
}));

const CreditSummary = () => {
    const creditsAmount = useSelector((state: RootState) => state?.credits.creditsAmount);
    const expirationDate = useSelector((state: RootState) => state?.credits.expirationDate);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const classes = useStyle();

    return (
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="75px">
                <Grid container>
                    {!isMobile &&
						<Grid item md={3} xs={12}>
						    <Navigation />
						</Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Card variant="outlined">
                            <Grid item xs={12} className={classes.wrapper}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Box marginBottom="33px">
                                            <Typography variant="h2">
												Appointment Summary
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="15px">
                                            <Typography className={classes.creditsCount}>
                                                {creditsAmount}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="10px">
                                            <Typography variant="h3">
												Available Appointments
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} style={{marginBottom: "20px"}}>
                                        <Link to="/purchaseCredits" className={classes.link}>
                                            <Button variant="contained" color="secondary">
												Purchase Appointment Bundle
                                            </Button>
                                        </Link>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="40px">
                                            {
                                                creditsAmount && expirationDate?
                                                    <Typography color="textSecondary" className={classes.textPlain}>
														Credits expire {moment(expirationDate).format("l")} if unused
                                                    </Typography>
                                                    :
                                                    <Typography color="textSecondary" className={classes.textPlain}>
														Save up to
                                                        <span className={classes.textAccent}> 24% </span>
														on appointments!
                                                    </Typography>
                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="20px">
                                            <Typography variant="h3">
												How Bundles Work
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="40px">
                                            <Typography color="textSecondary" className={classes.textPlain}>
												Appointments can be applied to prescription appointments (when legally available) and advice appointments. When requesting an appointment, you can apply 1 appointment credit to pay for the appointment.
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="20px">
                                            <Typography variant="h3">
												Expiration Details
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="40px">
                                            <Typography color="textSecondary" className={classes.textPlain}>
												Bundled appointments expire after 365 days with inactivity. If you purchase additional bundles prior to expiration, old appointments will rollover for another 365 days.
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="20px">
                                            <Typography variant="h3">
												Benefits
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box marginBottom="40px">
                                            <Typography color="textSecondary" className={classes.textPlain}>
												Purchasing a bundle of appointments reduces the cost per appointment.											</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default CreditSummary;
